var exports = {
  "N8": "labelsListContainer__hYL2FQ",
  "Ap": "labelDescriptionTooltip__3yeDxA",
  "eJ": "tooltipVisible__OdIxx8",
  "kJ": "tooltipHidden__npfDG4",
  "Ru": "labelLink__AJlImc",
  "RH": "removableLabelContainer__ylsCIj",
  "rt": "removeLabelButton__NRC3d2",
};

module.exports = exports;
